export default "__VITE_ASSET__4ddb03b5__"